<div class="modal-backdrop">
  <div class="modal-content calculator-modal">
    <button class="close-btn" (click)="close.emit()">&times;</button>
    <div class="modal-body">
      <div class="modal-left">
        <h2>CALCULATE THE INTERNATIONAL SHIPPING COMPANIES RATE</h2>
        <p class="subtitle">for your order!</p>
        <button class="calculate-btn" (click)="goToCalculator();close.emit();">Calculate</button>
      </div>
      <div class="modal-right">
        <img src="https://d1we2hgzmci25y.cloudfront.net/assets/img/signup-background-woman.webp" alt="Shipping Calculator" />
      </div>
    </div>
  </div>
</div> 